import { IconBrandChrome, IconHelp } from '@tabler/icons';

const icons = { IconBrandChrome, IconHelp };

const other = {
  id: 'sample-docs-roadmap',
  type: 'group',
  children: [
    {
      id: 'sample-page',
      title: 'No Access',
      type: 'item',
      url: '/',
      icon: icons.IconBrandChrome,
      breadcrumbs: false
    }
  ]
};

export default other;
